import React, { useMemo } from 'react';
import getRandomBanner from 'util/getRandomBanner';

export const ProfileImage = ({ photo, name }) => {
  const defaultImage = useMemo(() => getRandomBanner(), []);

  return <img src={photo || defaultImage} alt={`${name} Profile Photo`} />;
};
